<template>
  <div class="tabpane">
    <div class="line"></div>
    <div class="text">{{title}}</div>
  </div>
</template>
<script>
export default {
    props:{
        title:{
          type:String,
        },
        
      },
  
}
</script>
<style lang="less" scoped>
.tabpane{
  margin-top: 20px;
  height: 42px;
  background: #E5F4EE;
  width: 100%;
  // margin-left: 20px;
  // box-sizing: border-box;
  display: flex;
  .line{
    width: 4px;
    height: 42px;
    background: #169F6A;
  }
  .text{
        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #00955B;
        padding-left: 14px;
        line-height: 42px;
    }
  
}
</style>


// WEBPACK FOOTER //
// src/components/headerTitle/bigScreenTitleBorder.vue